import type { ComponentProps } from "react";

import { AutocompleteInput } from "@/components/admin/autocomplete-input";

import { useDistinctValues } from "./useDistinctValues";

type Props = Omit<ComponentProps<typeof AutocompleteInput>, "choices"> & {
  /** Resource and column the existing values are read from. */
  valuesResource: string;
  valuesField: string;
  baseValues?: readonly string[];
};

const createChoice = (value?: string) => {
  const text = value?.trim();
  return text ? { id: text, name: text } : undefined;
};

/**
 * Autocomplete listing every value already in use (plus `baseValues`) that
 * also lets the user type a brand new value.
 */
export const FreeTextAutocompleteInput = ({
  valuesResource,
  valuesField,
  baseValues,
  ...props
}: Props) => {
  const choices = useDistinctValues(valuesResource, valuesField, baseValues);
  return (
    <AutocompleteInput
      {...props}
      choices={choices}
      optionText="name"
      translateChoice={false}
      onCreate={createChoice}
      createItemLabel="Use “%{item}”"
      clearable
      helperText={false}
    />
  );
};
